import devapis from "./dev.endpoints";
import stagingapis from "./staging.endpoints";
import prodapis from "./prod.endpoints";
const localtodev = "http://localhost:3000,http://localhost:3001,";
const localtostage = "";
const localtoprod = "";

export const endpoints = {
    "dev": {
        "base": `${localtodev}https://devportal.impetusaisolutions.com`,
        "api_base": "https://devimpetusapi.impetusaisolutions.com",
        "static_token": "",
        ...devapis,
        "open/login": {
            "base": `${localtodev}https://devportal.impetusaisolutions.com`,
            "api_base": "https://devimpetusapi.impetusaisolutions.com",
            ...devapis,
        },
    },
    "staging": {
        "base": `${localtostage}https://devportal.impetusaisolutions.com`,
        "api_base": "https://devimpetusapi.impetusaisolutions.com",
        "static_token": "",
        ...stagingapis,

        "open/login": {
            "base": "https://devportal.impetusaisolutions.com",
            "api_base": "https://devimpetusapi.impetusaisolutions.com",
            ...stagingapis,
        },
    },
    "production": {
        "base": `${localtoprod}https://portal.starpowerzdigiloans.com`,
        "api_base": "https://apiprtl.starpowerzdigiloans.com/api/v1",
        "static_token": "",
        ...prodapis,

        "open/login": {
            "base": "https://portal.starpowerzdigiloans.com",
            "api_base": "https://apiprtl.starpowerzdigiloans.com/api/v1",
            ...prodapis,
        },
    }
}

export default endpoints;